import React from 'react';
import construction from '../assets/undraw_building_blocks_n0nc.svg';

const BlogPage = () => (
  <div className="blog-container">
    <div>
      <img className="img-blog" alt="blog loading " src={construction} />
    </div>
  </div>
);

export default BlogPage;



// WEBPACK FOOTER //
// ./src/pages/BlogPage.js